const wrappers = {
    asArray: function(data) {
        return data instanceof Array ? data : [data];
    }
};

export {
    wrappers
}